// extracted by mini-css-extract-plugin
module.exports = {"unverifiedContentContainer":"_1BVYVMca","suggestedFieldsContainer":"_3DEP_cdR","unverifiedImage":"_2h-OMORp","suggestedField":"_3w-o1oyN","actions":"_2GVvZsD6","noPadding":"_3X_d2_lx","inputField":"_3oU1-zqR","saveButton":"_3DisreXd","containerFlexColumn":"_1UAnhFmF","containerFlexRow":"_3212ySlN","basicInfoTop":"AKLleBZj","inputError":"mtFvJIGQ"};
    if(module.hot) {
      // 1754514949104
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  